* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.notes-list-container {
  height: calc(100% - 60px);
  overflow: hidden;

  &.is-loading {
    .loading-state-container {
      display: block;
    }

    .empty-state-container {
      display: none;
    }

    .notes-list {
      display: none;
    }
  }
}

.overlay {
  display: none;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: var(--chart-050-hover);
  z-index: 1100;

  &.visible {
    display: block;
  }
}

.back-btn {
  margin-top: calc(var(--spacer) * 2.5);

  &::part(button-text) {
    height: 100%;
  }
}

.notes-list-title {
  padding: calc(var(--spacer) * 7) calc(var(--spacer) * 2) 0 calc(var(--spacer) * 2);
  color: var(--main-titles-inputs-600);

  &.with-back-btn {
    padding-top: calc(var(--spacer) * 2);
  }
}

.loading-state-container {
  padding: calc(var(--spacer) * 2);
  display: none;
}

.empty-state-container {
  height: calc(100% - 81px);

  .empty-state-title {
    margin-bottom: calc(var(--spacer) * 2 - 4px);
  }

  .empty-state-text {
    margin-bottom: calc(var(--spacer) * 3);
  }
}

.notes-list {
  padding-bottom: calc(var(--spacer) * 2);
  height: calc(100% - 60px);
  overflow: hidden;
  overflow-y: scroll;

  gz-note-card {
    padding: 0 var(--spacer) calc(var(--spacer) * 2) calc(var(--spacer) * 2);

    &:first-of-type {
      padding: calc(var(--spacer) * 2) var(--spacer) calc(var(--spacer) * 2) calc(var(--spacer) * 2);
    }
  }

  .add-note-button-container {
    display: block;
    height: 32px;
    width: 100%;
    background-color: var(--white-layout-303-level-2-elevation);

    .add-note-button {
      position: absolute;
      bottom: calc(var(--spacer) * 2);
      left: calc(var(--spacer) * 2);
    }
  }
}

.note-editor-container {
  position: absolute;
  width: 100%;
  bottom: 0;

  gz-note-editor {
    border-top: 1px solid var(--chart-101-pressed-dividers);

    &::part(wrapper) {
      z-index: 1150;
      background-color: var(--white-layout-303-level-2-elevation);
      height: auto;
    }
  }
}
